import vuetify from '@/plugins/vuetify/vuetify'

const mq = window.matchMedia('(prefers-color-scheme: dark)')

export const addSystemThemeListener = function() {
    console.log('addSystemThemeListener')
    mq.addEventListener('change', setVuetifyThemeFromSystem)
}

export const removeSystemThemeListener = function() {
    console.log('removeSystemThemeListener')
    mq.removeEventListener('change', setVuetifyThemeFromSystem)
}

export const setVuetifyThemeFromSystem = function() {
    console.log('setVuetifyThemeFromSystem')
    vuetify.framework.theme.dark = mq.matches
}

////////////////////////////////////////////////

const state = () => ({
    theme: 'light',
})

// this.$store.getters['preferences/preferenceAtPath']('pagination.perPage')
const getters = {
    theme: (state, getters, rootState, rootGetters) => {
        const theme = state.theme
        console.log('VUEX preferences getters theme', theme)
        return theme
    },
}

// $store.dispatch('theme/setTheme')
const actions = {
    ////////////////////////////////////////////////
    // start actions message center
    ////////////////////////////////////////////////
    setTheme: ({ commit, state, getters, dispatch }, payload) => {
        let thePayload = payload.payload
        console.log('VUEX theme actions setTheme thePayload', thePayload)

        let theme = thePayload.preference
        console.log('VUEX theme actions setTheme theme', theme)

        commit('SET_THEME', theme)

        if (theme === 'light') {
            removeSystemThemeListener()
            vuetify.framework.theme.dark = false
        } else if (theme === 'dark') {
            removeSystemThemeListener()
            vuetify.framework.theme.dark = true
        } else if (theme === 'system') {
            addSystemThemeListener()
            setVuetifyThemeFromSystem()
        }

        console.log('VUEX theme actions setTheme payload', payload.payload)
        commit('preferences/SET_PREFERENCE_AT_PATH', payload.payload, { root: true })
    },
    ////////////////////////////////////////////////
    // end actions message center
    ////////////////////////////////////////////////
}

// this.$store.commit('preferences/SET_PREFERENCE_AT_PATH', payload)
const mutations = {
    SET_THEME: (state, payload) => {
        state.theme = payload
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
